import { createContext } from "react";
import { Notification } from "@hooks/useGetNotifications";

interface NotificationContextType {
  notifications: Notification[];
  hasUnreadNotifications: boolean;
}

interface DefaultValueType {
  notifications: Notification[];
  hasUnreadNotifications: boolean;
}

const defaultValue: DefaultValueType = {
  notifications: [],
  hasUnreadNotifications: false,
};

// Create context with default values
export const NotificationsContext =
  createContext<NotificationContextType>(defaultValue);
